export const ADD_ALL_TEMPLATES = "ADD_ALL_TEMPLATES";
export const REMOVE_ALL_TEMPLATES = "REMOVE_ALL_TEMPLATES";
export const EDIT_TEMPLATE_BY_INDEX = "EDIT_TEMPLATE_BY_INDEX";
export const REMOVE_TEMPLATE_BY_INDEX = "REMOVE_TEMPLATE_BY_INDEX";
